export default __webpack_public_path__ + "9b609db0ab06c374c895b50b32b42f0c.svg";